import { render } from "./FormLayoutDemo.vue?vue&type=template&id=ef0a11a8"
import script from "./FormLayoutDemo.vue?vue&type=script&lang=js"
export * from "./FormLayoutDemo.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__